export default {
    title: "Umfrage eingereicht",
    header: "@:views.survey.submitted.title",
    message: "Danke für Ihre Rückmeldung.",
}